// elements/sailboat-42.js
import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/sailboat/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.sailboat":"To fugler og en seileb\xE5t p\xE5 vannet"}');

// src/raw/sailboat/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.sailboat":"Two birds and a sailboat on water"}');

// src/raw/sailboat/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.sailboat":"Kaksi lintua taivaalla ja purjevene vedess\xE4"}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages4 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages4);
  i18n.activate(locale);
};

// elements/sailboat-42.js
activateI18n(messages2, messages, messages3);
var IconSailboat42 = class extends LitElement {
  render() {
    const title = i18n2.t({ message: `Two birds and a sailboat on water`, id: "icon.title.sailboat", comment: "Title for sailboat icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-sailboat-42-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m33 23.428 3.119-6.236a.43.43 0 0 0-.383-.62H6.266a.43.43 0 0 0-.384.62L9 23.428"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.857 25.073c1.241.168 2.5.031 3.687-.402a8.3 8.3 0 0 0 3.17-2.1 7 7 0 0 0 2.329 1.849c.886.43 1.845.653 2.814.653s1.928-.222 2.814-.653A7 7 0 0 0 21 22.57a7 7 0 0 0 2.329 1.849c.886.43 1.844.653 2.814.653s1.928-.222 2.814-.653a7 7 0 0 0 2.329-1.849 8.3 8.3 0 0 0 3.17 2.1 7.7 7.7 0 0 0 3.64.409M10.732 3.733l1.696 1.696 1.696-1.696M5.592 8.878l1.694 1.693 1.693-1.693M21 2.857l12 10.286H21zm0 13.714v-3.428"></path></svg>`;
  }
};
if (!customElements.get("w-icon-sailboat-42")) {
  customElements.define("w-icon-sailboat-42", IconSailboat42);
}
export {
  IconSailboat42
};
//# sourceMappingURL=sailboat-42.js.map
